
































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Tab from "@/components/App/Modules/GMS/Dashboard/components/Tabs.vue";
import PendingActionComponent from "@/components/App/Modules/GMS/Communication/Dashboard/PendingAction.vue";
import CommiunicationDashboardListComponent from "./CommunicationList.vue";

@Component({
  components: { Tab, PendingActionComponent,CommiunicationDashboardListComponent},
})
export default class CommunicationApplicantSummaryComponent extends Vue {
  tabItems: any = [
    { component: "PendingActionComponent", text: "Pending Actions" },
    { component: "CommiunicationDashboardListComponent", text: "Communication" },
  ];

  activeTabComponent: string = this.tabItems[0].component;
  items: any = [];
  filters: any = [];


  loadComponent(tab) {
    this.items = [];
    this.activeTabComponent = tab.component;
  }

  onSearch() {
    
  }

}
